import * as React from 'react';
export const chevronUpSvg = React.forwardRef(function chevronUpSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M.606 5.666a.776.776 0 0 1-.231-.549.747.747 0 0 1 .209-.51l2.875-3a.75.75 0 0 1 1.082-.001L7.416 4.6a.72.72 0 0 1 .209.516.75.75 0 0 1-1.291.522L4 3.21 1.667 5.643a.75.75 0 0 1-1.06.022Z',
    }),
  );
});
chevronUpSvg.defaultProps = {
  width: '8',
  height: '8',
  viewBox: '0 0 8 8',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var chevronUp = {
  category: 'icon',
  colorable: true,
  name: 'chevronUp',
  svg: chevronUpSvg,
};
